import { render, staticRenderFns } from "./book-summary.vue?vue&type=template&id=42c9e1be&scoped=true&"
import script from "./book-summary.vue?vue&type=script&lang=js&"
export * from "./book-summary.vue?vue&type=script&lang=js&"
import style0 from "./book-summary.vue?vue&type=style&index=0&id=42c9e1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9e1be",
  null
  
)

export default component.exports